import trackEvent from '@/track/trackEvent'

// 登陆弹窗展现
const loginShow = () => {
  trackEvent.track('login_show', {})
}

// 点击登录
const clickLogin = () => {
  trackEvent.track('click_login', {})
}

// 登录成功
const loginSuccess = (userId: string) => {
  trackEvent.track('login_success', {
    user_unique_id: userId
  })
}

// 登录失败
const loginFail = (error_code: string) => {
  trackEvent.track('login_fail', {
    error_code
  })
}

export default {
  loginShow,
  clickLogin,
  loginSuccess,
  loginFail
}
